import React, { useState, useEffect } from 'react';
import { ListGroup } from 'react-bootstrap'; // Assuming you're using React Bootstrap


import Breadcrumb from '../../Breadcrumb/Main'
import Header from '../../headerone/Main'
import { Container, Row, Col } from "react-bootstrap";
import { Link } from 'react-router-dom';

const YourComponent = () => {
    const [selectedItem, setSelectedItem] = useState('Director Office'); // Set default selected item

    const [DirectorOfficers, setDirectorOfficers] = useState([
        // Sample data similar to your provided JSON

          // Director Office
        {
            Name: "Mr. Sahad Parammal ",
            Position: "Junior Superintendent",
            Email: "parammal@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sahad%20photo.jpg",
            MenuName: "Director Office"
        },

        {
            Name: "Mr. Udaiyakumar R",
            Position: "Junior Assistant",
            Email: "udaya@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/uday.png",
            MenuName: "Director Office"
        },

          // Registrar Office
        {
            Name: "Ms. Arcot Likhitha ",
            Position: "Junior Assistant",
            Email: "likhitha@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arcot_Likhitha_JA.jpg",
            MenuName: "Registrar Office"
        },
        {
            Name: "Mr. Bekkesigandla Vamsi Krishna ",
            Position: "Junior Assistant",
            Email: "kvamsi105@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bekkesigandla_Vamsi_Krishna_JA.png",
            MenuName: "Registrar Office"
        },
        // {
        //     Name: "Ms. Supraja Akkala ",
        //     Position: "Junior Assistant",
        //     phoneno: "",
        //     Email: "",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Supraja.jpg",
        //     MenuName: "Registrar Office"
        // },

       // {
         //   Name: "Mr. Chaman Mehta",
         //   Position: "Deputy Registrar",
         //   phoneno: "0877 250 3507",
         //   Email: "chaman@iittp.ac.in",
         //   Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
         //   MenuName: "General Administration"

       // },
          // Dean's Office
          {
            Name: "Mr. Nagapatla Gnanasekhar",
            Position: "Junior Assistant",
            Email: "gnan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/gnanasekhar.jpg",
            Department: "Office of Dean - Faculty Affairs",
            MenuName: "Dean Office"
            
        },
        // {
        //     Name: "Ms. Bandi Nandini",
        //     Position: "Junior Assistant",
        //     Email: "bandinandini@iittp.ac.in",
        //     phoneno: " ",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bandi_Nandini_JA.png",
        //     Department: "Office of Dean - IAA",
        //     MenuName: "Dean Office" // MenuName information is not provided in the HTML
            
        // },

         // General Administration
        {
            Name: "Shri Umesh Kumar Singh",
            Position: "Assistant Registrar",
            phoneno: "0877 250 3535",
            Email: "umesh@iittp.ac.in",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
            MenuName: "General Administration"
        },
        {
            Name: "Mr. M. Venkat Ramana",
            Position: "Assistant Registrar",
            Email: "mvramana@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkat_Ramana_AR.png",
            MenuName: "General Administration"
        },
        {
            Name: "Mr. Abdul Rafi",
            Position: "Junior Assistant",
            Email: "rafi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rafi.jpg",
            MenuName: "General Administration"
        },
        {
            Name: "Mr. Avva Venkatesh",
            Position: "Junior Assistant",
            Email: "avvavenky5@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkatesh_Avva_JA.png",
            MenuName: "General Administration"
            
            
        },    
        {
            Name: "Mr. Chakra Varthi Kandregula",
            Position: "Assistant Security Officer",
            Email: "chakravarthi.aso@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mr%20Chakravarthi%20K.PNG",
            MenuName: "General Administration"
        },

          // Establishment Section
        {
            Name: "Mr. Chaman Mehta",
            Position: "Deputy Registrar",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Establishment"
        },
        {
            Name: "Ms. Sheela Reddy T",
            Position: "Assistant Registrar (SS)",
            Email: "sheela@iittp.ac.in",
            phoneno: "0877 250 3504",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sheela.jpg",
            MenuName: "Establishment"

        },
        {
            Name: "Mr. Srinivasulu K V",
            Position: "Junior Superintendent",
            Email: "kvsrinivasulu@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS.jpg",
            MenuName: "Establishment"
        },
       
        // {
        //     Name: "Mr. Md Omar Abdul Aziz",
        //     Position: "Junior Assistant",
        //     Email: "omarabdul12214@iittp.ac.in",
        //     phoneno: "0877 250 3503",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohammed_Omar_Abdul_Aziz_JA.png",
        //     MenuName: "Establishment"
        // },

        {
            Name: "Ms. Bandi Nandini",
            Position: "Junior Assistant",
            Email: "bandinandini@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bandi_Nandini_JA.png",
            MenuName: "Establishment" // MenuName information is not provided in the HTML
        },
        
        {
            Name: "Mr. Y Vamsi Krishna",
            Position: "Junior Assistant",
            Email: "vamsi@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/photo.jpeg",
            MenuName: "Establishment"
        },
        {
            Name: "Mr. Vijay S",
            Position: "Junior Assistant",
            Email: "vijaysekar@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijay_S_JA.png",
            MenuName: "Establishment"
        },
       
       

          // Estate Office
        {
            Name: "Mr. Chaman Mehta",
            Position: "Deputy Registrar & Estate Officer",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Estate Office"
        },

          // Academic Section

        {
            Name: "Mr. Harikrishna Reddy",
            Position: "Assistant Registrar (SS)",
            Email: "harikrishna@iittp.ac.in",
            phoneno: "0877 250 3530",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
            MenuName: "Academic Affairs"
        },
        {
            Name: "Mr. Madhu N",
            Position: "Assistant Registrar",
            Email: "madhunair@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/madhun.png",
            MenuName: "Academic Affairs"

        },
        {
            Name: "Mrs. Sandhya Y",
            Position: "Section Officer",
            Email: "sandhyayellapragada@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sandhya.jpg",
            MenuName: "Academic Affairs"
        },

        
        {
            Name: "Mr. K Prasad Rao",
            Position: "Junior Superintendent",
            Email: "prasadrao@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/PRASAD RAO K.jpg",
            MenuName: "Academic Affairs"
        },
       
       
       
        {
            Name: "Mr. Mohammad Ishaq Alikhan",
            Position: "Junior Superintendent",
            Email: "ishaq@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ishaq_2.jpg",
            MenuName: "Academic Affairs"
        },
        {
            Name: "Mr. Ganjikunta Balaji Kiran",
            Position: "Junior Assistant",
            Email: "balajikiran@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ganjikunta_balaji%20kiran_JA.jpg",
            MenuName: "Academic Affairs"
        }, 

        {
            Name: "Mr. P. Vidyasagar",
            Position: "Junior Assistant",
            Email: "vsp@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vidyasagar.jpg",
            MenuName: "Academic Affairs"
        },
        
        {
            Name: "Mr. KVS Roshan Kishore",
            Position: "Junior Assistant",
            Email: "roshankishore@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KVS_Roshan%20Kishore_JA.jpg",
            MenuName: "Academic Affairs"
        },
        {
            Name: "Ms. Basila Ali",
            Position: "Junior Assistant",
            Email: "basilaali@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Basila_Ali_JA.png",
            MenuName: "Academic Affairs"
        },

          // Accounts Section
        {
            Name: "Mr. Rajan Babu Lankapalli",
            Position: "Deputy Registrar",
            Email: "rajanbabul@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rajanbabu.png",
            MenuName: "Accounts"
        },
        {
            Name: "Mr. Arun Kalyan Kuppannagari",
            Position: "Assistant Registrar",
            Email: "akk@iittp.ac.in",
            phoneno: "0877 250 3508",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arun%20Kuppannagari.jpg",
            MenuName: "Accounts"
        },
        {
            Name: "Mr. Sivasankara Reddy",
            Position: "Audit Officer",
            Email: "sivasankar@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sivasankara.jpg",
            MenuName: "Accounts"
        },
       
        {
            Name: "Mr. Amit Kumar Goswami",
            Position: "Junior Superintendent",
            Email: "amitgoswami@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Amit_G.JPG",
            MenuName: "Accounts"
        },
        {
            Name: "Mr. P. Midhun Kumar",
            Position: "Senior Assistant",
            Email: "midhunkumar07@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/midhun.jpg",
            MenuName: "Accounts"
        },
        {
            Name: "Mr. G. Ramoji Rao",
            Position: "Senior Assistant",
            Email: "ramji@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramji.jpg",
            MenuName: "Accounts"
        },
        {
            Name: "Mr. V Dinesh Kumar",
            Position: "Junior Assistant",
            Email: "vdinesh@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/dinesh.jpg",
            MenuName: "Accounts"
        },
       
        {
            Name: "Mr. Kasimsetty Sai Ramkrishna",
            Position: "Junior Assistant",
            Email: "ksairamkrishna@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kamishetty%20sai%20Ram%20krishna_JA.jpg",
            MenuName: "Accounts"
        },
        {
            Name: "Mr. Ithih Joy",
            Position: "Junior Assistant",
            Email: "ithihjoy3002001@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ithih_Joy_JA.png",
            MenuName: "Accounts"
        },

          // Purchase Section
        {
            Name: "Mr. Ramesh. R",
            Position: "Assistant Registrar",
            Email: "rameshr@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramesh_photo.JPG",
            MenuName: "Purchase & Stores"
        },
        {
            Name: "Mr. Ravula Chandrashekar",
            Position: "Junior Superintendent",
            Email: "rchandrashekar@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ravula_Chandrashekar_JS.png",
            MenuName: "Purchase & Stores"
        },
       
        {
            Name: "Mr. Sankar Naidu. L",
            Position: "Junior Superintendent",
            Email: "shankar@iittp.ac.in",
            phoneno: "0877 250 3503",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/shankarnaidu.jpg",
            MenuName: "Purchase & Stores"
        },

                // {
        //     Name: "Mr. CH K Venkata Mani Brahmam",
        //     Position: "Junior Assistant",
        //     phoneno: "", // No phone number provided in the HTML
        //     Email: "", // No email provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/mani.JPG",
        //     MenuName: "Purchase & Stores"
        // },
        {
            Name: "Mr. Manicharan Chintakrindi",
            Position: "Junior Assistant",
            Email: "manicharan@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/manicharan.jpg",
            MenuName: "Purchase & Stores"
        },
        
       
        {
            Name: "Mr. Saligari Akhil Rathna",
            Position: "Junior Assistant",
            Email: "akhilrathna@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/akhil.jpg",
            MenuName: "Purchase & Stores"
        },
       // {
       //     Name: "Mr. Ameer Zerwani",
       //     Position: "Junior Assistant",
       //     phoneno: "", // No phone number provided in the HTML
       //     Email: "", // No email provided in the HTML
       //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ameer.jpg",
       //     MenuName: "Purchase & Stores"
       // },
       // {
       //     Name: "Mr. Ajay J",
       //     Position: "Junior Assistant",
       //     phoneno: "", // No phone number provided in the HTML
       //     Email: "", // No email provided in the HTML
       //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mr_Ajay_J_JA.JPG",
       //     MenuName: "Purchase & Stores"
       // },
        {
            Name: "Mr. Ajsal EA",
            Position: "Junior Assistant",
            Email: "ajsal@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/MR_Ajsal_JAEA_JA.jpg",
            MenuName: "Purchase & Stores",
        },
        {
            Name: "Mr. A Mohan Krishna",
            Position: "Junior Assistant",
            Email: "mohankrishna@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohan_JA.png",
            MenuName: "Purchase & Stores",
        },

          // Hindi Cell
        {
            Name: "Shri Umesh Kumar Singh",
            Position: "Assistant Registrar Head, Hindi Cell",
            phoneno: "0877 250 3535",
            Email: "umesh@iittp.ac.in",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/umeshkumarsingh.png",
            MenuName: "Hindi Cell"
        },
        {
            Name: "Smt C. Vijayalakshmi",
            Position: "Hindi Consultant",
            Email: "vijayalakshmi@iittp.ac.in",
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijayalakshmi.jpeg",
            MenuName: "Hindi Cell"
        },
        {
            Name: "Mr. Aman Kumar Pandey",
            Position: "Hindi Translator",
            Email: "aman.hindi@iittp.ac.in",
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Aman_Kumar_HT.png",
            MenuName: "Hindi Cell"
        },


        // Departments

        // {
        //     Name: "Ms. Pallagani Maneesha",
        //     Position: "Junior Assistant",
        //     phoneno: "", // No phone number provided in the HTML
        //     Email: "", // No email provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pallagani_Maneesha_JA.jpg",
        //     MenuName: "Departments",
        //     Department: "Chemical Engineering"
        // },
        {
            Name: "Mrs. Maharasi E",
            Position: "Junior Assistant",
            Email: "maharasi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/maharasi.png",
            MenuName: "Departments",
            Department: "Chemical Engineering"
        },
        {
            Name: "Mr. Manukonda Syambabu",
            Position: "Junior Assistant",
            Email: "syambabumanukonda4818@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Manukonda_Syambabu_JA.png",
            MenuName: "Departments",
            Department: "Chemistry"
        },
        
        {
            Name: "Mr. B Vijay Kumar Naik",
            Position: "Junior Assistant",
            Email: "vijaykumarnaik.vk@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijay_Kumar_Naik_JA.png",
            MenuName: "Departments",
            Department: "Computer Science & Engineering"
        },

        {
            Name: "Mr. S Sunil Kumar Bharadwaj",
            Position: "Junior Assistant",
            Email: "sskbharadwaj@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sunil_Kumar_Bharadwaj.png",
            MenuName: "Departments",
            Department: "Civil & Environmental Engineering"
        },
        {
            Name: "Ms. Akalamkam Venkata Krishna Sravanthi",
            Position: "Junior Assistant",
            Email: "sravanthiakalamkam@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sravanthi_Akalamkam_Venkata_Krishna_JA.png",
            MenuName: "Departments",
            Department: "Electrical Engineering"
        },
        {
            Name: "Mr. Kishore Reddy Lavanuru",
            Position: "Junior Assistant",
            Email: "lavanurukishore@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Kishore_Reddy_Lavanuru_JA.jpg",
            MenuName: "Departments",
            Department: "Mathematics & Statistics"
        },
        {
            Name: "Mr. Vemuru Sree Varun Tej",
            Position: "Junior Assistant",
            Email: "varuntej@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vemuru_Sree_Varun_Tej_JA.png",
            MenuName: "Departments",
            Department: "Mechanical Engineering"
        },
        {
            Name: "Mrs. Gunturu Haritha",
            Position: "Junior Assistant",
            Email: "haritha@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/haritha.jpg",
            MenuName: "Departments",
            Department: "Physics"
        },
        {
            Name: "Ms. M Anitha Krishna Naik",
            Position: "Junior Assistant",
            Email: "anitha2000@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Anitha_Krishna_Naik_M_JA.png",
            MenuName: "Departments",
            Department: "Humanities and Social Sciences"
        },
        

        
        


        // EngineeringUnit

        {
            Name: "Mr. R S K Chaitanya Kotagiri",
            Position: "Executive Engineer",
            Email: "rskc@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/KRSK_Chaitanya.png",
            MenuName: "EngineeringUnit"
        },
        {
            Name: "Mr. Sadgurumoorthy Narni",
            Position: "Assistant Executive Engineer - Civil",
            Email: "nsm@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sadgurumoorthy Narni.png",
            MenuName: "EngineeringUnit"
        },
        {
            Name: "Mr. P Mallikarjuna Reddy",
            Position: "Assistant Executive Engineer – Electrical",
            Email: "pmreddy@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/P_Mallikarjuna.png",
            MenuName: "EngineeringUnit"
        },

        {
            Name: "Mr. G Venkata Subba Reddy",
            Position: "Horticulture Officer",
            Email: "gvsubbareddy@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/GVSReddy.png",
            MenuName: "EngineeringUnit"
        },

        {
            Name: "Mr. Senthamil Selvan",
            Position: "Assistant Engineer - Civil",
            Email: "selvan@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/tamil-new-photo.jpg",
            MenuName: "EngineeringUnit"
        },
        {
            Name: "Mr. Chaitanya Subba Reddy",
            Position: "Junior Engineer - Electrical",
            Email: "csrt@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaitanyareddy.jpg",
            MenuName: "EngineeringUnit"
        },
  

        {
            Name: "Mr. Nallam Manoj",
            Position: "Junior Engineer - Civil",
            Email: "nmanoj@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Nallam_Manoj_JE-Civil.png",
            MenuName: "EngineeringUnit"
        },
        {
            Name: "Mr. Gattu Aravind",
            Position: "Junior Engineer - Mechanical",
            Email: "gattuaravind@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Gattu_Aravind_JE.jpg",
            MenuName: "EngineeringUnit"
        },
        {
            Name: "Mr. R Niranjan",
            Position: "Senior Technician - Electrical",
            Email: "niranjan@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/R_Niranjan.png",
            MenuName: "EngineeringUnit"
        },

        {
            Name: "Ms. G Sravya",
            Position: "Junior Technician - Electrical",
            Email: "sravyagorapalli@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sravya.jpg",
            MenuName: "EngineeringUnit"
        },
        {
            Name: "Mr. G Ravi",
            Position: "Junior Technician - Electrical",
            Email: "ravi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/G_Ravi.png",
            MenuName: "EngineeringUnit"
        },

        // Computer Centre

        {
            Name: "Mr. P Vamshi Seshasayan",
            Position: "Technical Officer",
            Email: "vamshi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/vamshi.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mrs. R. Aswini",
            Position: "Technical Superintendent",
            Email: "aswinir@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/aswini_photo.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. T. Senthil",
            Position: "Technical Superintendent",
            Email: "senthil@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/senthil.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. G Ramesh",
            Position: "Junior Technical Superintendent",
            Email: "ramesh@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rameshg.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. B.S. Ramkumar",
            Position: "Junior Technical Superintendent",
            Email: "ramkumar@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramkumar_jts.jpg",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. Ajithraj. R. A",
            Position: "Junior Technical Superintendent",
            Email: "ajithraj@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ajithraj_Jts.jpeg",
            MenuName: "Computer Centre"
        },

        {
            Name: "Mr. Akhil A Chacko",
            Position: "Junior Technical Superintendent",
            Email: "akhil.chacko@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Akhil_JTS_CC.png",
            MenuName: "Computer Centre"
        },
        {
            Name: "Mr. Janga Ananda Babu",
            Position: "Junior Technician",
            Email: "anandajanga@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ananda_Babu_Janga_JT.png",
            MenuName: "Computer Centre"
        },

        // Health Care


        {
            Name: "Dr. Venkata Ramarao Kintali MBBS, DNB, FCD, CTCCM",
            Position: "Senior Medical Officer",
            Email: "drkvr@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramarao.png",
            MenuName: "Health Care"
        },
        {
            Name: "Dr. Sruthi Kodidini  MBBS, MD.OBG",
            Position: "Medical Officer",
            Email: "sruthikodidini@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sruthi.jpg",
            MenuName: "Health Care"
        },
        {
            Name: "Mrs. Pakala Nagamani",
            Position: "Staff Nurse",
            Email: "nagamani@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/nagamani.png",
            MenuName: "Health Care"
        },
        {
            Name: "Mr. J Sesha Naidu",
            Position: "Staff Nurse",
            Email: "jsnaidu@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/seshanaidu.jpg",
            MenuName: "Health Care"
        },

        {
           Name: "Mr. Praveen P",
            Position: "Junior Nursing Officer",
            Email: "praveenp@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Praveen_P_JNO.png",
            MenuName: "Health Care"
        },
        
        

        // Hostels

        {
            Name: "Mr. Harikrishna Reddy",
            Position: "Assistant Registrar",
            phoneno: "0877 250 3530", // No phone number provided in the HTML
            Email: "harikrishna@iittp.ac.in", // No email provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/HariKrishnaReddy.jpg",
            MenuName: "Hostels"
        },

        // IAA
        {
            Name: "Ms. Aparna Sai Ramesh",
            Position: "Assistant Program Administrator",
            Email: "aparna15@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Aparna_Sai_Ramesh_IAA.png",
            MenuName: "IAA"
        },
        {
            Name: "Ms. Addepalli Haritha",
            Position: "Junior Assistant",
            Email: "haritha17@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Addepalli_Haritha_JA.jpg",
            MenuName: "IAA"
        },
        
        // {
        //     Name: "Ms. Addepali Haritha",
        //     Position: "Junior Assistant",
        //    phoneno: "", // No phone number provided in the HTML
        //     Email: "", // No email provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Addepalli_Haritha_JA.jpg",
        //     MenuName: "IAA" // MenuName information is not provided in the HTML
        // },
       
        // Laboratories
        {
            Name: "Mr. Rapolu Mallikarjun",
            Position: "Junior Technical Superintendent",
            Email: "rmallichemical@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/mallikarjun.jpg",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. A K Suresh",
            Position: "Junior Technical Superintendent",
            Email: "aksuresh@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/suresh.jpg",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Balaram Tandelu",
            Position: "Junior Technician",
            Email: "tbalaram9@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Balaram.jpg",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
        {
            Name: "Mrs. Konduru Harika",
            Position: "Junior Technician",
            Email: "harika@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Harika_JA.jpg",
            Department: "Chemical Engineering",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. M. Jagadeesh",
            Position: "Technical Superintendent",
            Email: "jagam@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/jagadesh.jpg",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Sanyasinaidu Gottapu",
            Position: "Technical Superintendent",
            Email: "naidugottapu@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/naidu.jpg",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Sai Prabhath Upparu Gonabhavi",
            Position: "Junior Technician",
            Email: "saiprabhath@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sai_prabath_upparu_gonabhavi_JT.jpg",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Badavath Rambabu",
            Position: "Junior Technician",
            Email: "rambabujt001@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Badavath_Rambabu_JT.png",
            Department: "Chemistry",
            MenuName: "Laboratories"
        },
        // {
        //     Name: "Mr. T. Sai Praveen",
        //     Position: "Junior Technician",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Praveensai.jpg",
        //     Department: "Chemistry",
        //     MenuName: "Laboratories"
        // },
    

      //  {
        //    Name: "Mr. Nagarajan R",
        //    Position: "Junior Technical Superintendent",
        //    Email: "nagarajan@iittp.ac.in", // No email provided in the HTML
        //    phoneno: " ", // No phone number provided in the HTML
        //    Image: "https://files.iittp.ac.in/images/demo/iit/Staff/nagarajan_new.jpeg",
        //    Department: "Computer Science",
        //    MenuName: "Laboratories"
       // },
        {
            Name: "Mr. Gummuluri Sai Raj",
            Position: "Junior Technical Superintendent",
            Email: "sairaj@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Gummuluri_Sai_Raj_JTS.png",
            Department: "Computer Science",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Abijith P M",
            Position: "Junior Technician",
            Email: "abijith@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/abhijit.jpg",
            Department: "Computer Science",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. M. Suneel Kumar",
            Position: "Technical Officer",
            Email: "suneel@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/MSK.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. S Ruthrapathi",
            Position: "Technical Superintendent",
            Email: "ruthrapathis@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ruthrapathy.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. M. Sivanathan",
            Position: "Junior Technical Superintendent",
            Email: "sivanathan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sivanathan.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Priyangan A",
            Position: "Senior Technician",
            Email: "priyangan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Priyangan.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. M. Sunil Kumar",
            Position: "Senior Technician",
            Email: "manugondasunil@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/sunilkumar.jpg",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Naveen Kumar B M",
            Position: "Junior Technician",
            Email: "naveeniit@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Naveen_Kumar_B_M_JT.png",
            Department: "Civil",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Sreekanth Ramachandran",
            Position: "Junior Technician - Systems",
            Email: "sreekanth@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sreekanth_JT_CEE.png",
            Department: "Civil",
            MenuName: "Laboratories"
        },  
        {
            Name: "Mr. T Sathish Kumar",
            Position: "Technical Officer",
            Email: "sathishkumart@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sathish_Ele.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Pujari Dinesh Khanna",
            Position: "Technical Superintendent",
            Email: "pdkhanna@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/PUJARIDINESHKHANNA.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Y Suravardhana Reddy",
            Position: "Technical Superintendent",
            Email: "suravardhana@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/suravardhan.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. K N Dwaraka Natha",
            Position: "Junior Technical Superintendent",
            Email: "knd@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/dwarakanath.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Kollu Homprakash",
            Position: "Junior Technical Superintendent",
            Email: "homprakashk@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Homprakash.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Kumar Bellikatti",
            Position: "Junior Technical Superintendent",
            Email: "kbkatti@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/bellikatti.jpg",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Vijay Kumar Aakarapu",
            Position: "Junior Technical Superintendent",
            Email: "vijayaakarapu@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vijay_Kumar_Aakarapu.png",
            Department: "Electrical",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Babu Raj M",
            Position: "Technical Officer",
            Email: "Baburajm@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Baburaj.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. B. Ramesh Kumar",
            Position: "Technical Superintendent",
            Email: "beesam@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ramesh.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Prodduturu Dasthagiri",
            Position: "Technical Superintendent",
            Email: "dgiri@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/dasthagiri.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. S Venkata Narayana",
            Position: "Technical Superintendent",
            Email: "svn@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/narayana.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Sai Chaitanya Pilla",
            Position: "Technical Superintendent",
            Email: "chaitanya@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/chaitanyapilla.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Midathana Ramesh",
            Position: "Senior Technician",
            Email: "rameshmech@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/RameshM.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },


       
        {
            Name: "Mr. Keerthi Veera Venkata Satya Sai",
            Position: "Junior Technician",
            Email: "kvvsatyasai@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkata_Satya_Sai.jpg",
            Department: "Mechanical",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Voma Uday Kumar",
            Position: "Technical Superintendent",
            Email: "uday@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/uday.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. Durga Rama Pavan V",
            Position: "Junior Technical Superintendent",
            Email: "pavan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/durgarama.jpeg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Dr. P. Mohanapriya",
            Position: "Junior Technical Superintendent",
            Email: "mohana.physics@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mohanapriya.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Satishbabu Thota",
            Position: "Junior Technical Superintendent",
            Email: "tsbabu@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/satish.jpg",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. P Bharath Kumar",
            Position: "Junior Technician",
            Email: "pellurubharath@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bharath_JT_PH.png",
            Department: "Physics",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. RameshKrishnan A",
            Position: "Technical Superintendent",
            Email: "ark@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/ark.jpg",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. N Hanumanthu Rao Naik",
            Position: "Junior Technical Superintendent",
            Email: "nhraon@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Hanumanthrao.jpg",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        
        {
            Name: "Mr. Parthiban K",
            Position: "Senior Technician",
            Email: "kp@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/parthiban.jpg",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Bodele Shubham Sanjay",
            Position: "Junior Technician",
            Email: "shu.bodele@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bodele_Shubham_Sanjay_JT_WS.png",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Naveen Kumar",
            Position: "Junior Technician",
            Email: "naveenkumar01@iittp.ac.in", // No email provided in the HTML
            phoneno: "", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Naveen_JT_WS.png",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },
        {
            Name: "Mr. Nagendran C",
            Position: "Junior Technician",
            Email: "nagendran@iittp.ac.in", // No email provided in the HTML
            phoneno: "", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Nagendran_JT_WS.png",
            Department: "WorkShop",
            MenuName: "Laboratories"
        },

        // Library

        {
            Name: "Mr. Prashanta Kumar Behera",
            Position: "Deputy Librarian",
            Email: "pkbehera@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Prashanta_Kumar_Behera_DL.png",
            MenuName: "Library"
        },

        {
            Name: "Mr. Shameer K K",
            Position: "Assistant Librarian (SS)",
            Email: "shameer@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Shameer.jpg",
            MenuName: "Library"
        },
        {
            Name: "Dr. Fathima Azra Fazal",
            Position: "Junior Technical Superintendent",
            Email: "azra@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/azra.jpg",
            MenuName: "Library"
        },
        {
            Name: "Mr. Pramod Kumar Meher",
            Position: "Junior Library Superintendent",
            Email: "pramod@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Pramod.png",
            MenuName: "Library"
        },
        {
            Name: "Mr. Mahadev Shahaji Mohite",
            Position: "Junior Library Technician",
            Email: "mahadev@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Mahadev.png",
            MenuName: "Library"
        },

        //Recruitment
        {
            Name: "Mr. S. L. Pradeep Valan",
            Position: "Assistant Registrar",
            Email: "slpvalan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/valan.jpg",
            MenuName: "Recruitment"
        },
        {
            Name: "Mr. Singareddy Anjaneyulu",
            Position: "Junior Superintendent",
            Email: "anji@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/AnjaneyuluS.jpg",
            MenuName: "Recruitment"
        },
        // {
        //     Name: "Mr. Alok Prakash Tripathi",
        //     Position: "Junior Superintendent",
        //     Email: "alok.tripathi@iittp.ac.in", // No email provided in the HTML
        //     phoneno: " ", // No phone number provided in the HTML
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Alok_Prakash_Tripathi_JS.jpg",
        //     MenuName: "Recruitment"
        // },
        {
            Name: "Mr. Nagapatla Gnanasekhar",
            Position: "Junior Assistant",
            Email: "gnan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/gnanasekhar.jpg",
            MenuName: "Recruitment"
        },

        // NSS Section

        {
            Name: "Mr. Mahesh Kumar Mulakala",
            Position: "NSS Program Officer",
            Email: "maheshkumar@iittp.ac.in",
            phoneno: "9866454684",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/maheshkumar.jpg",
            MenuName: "NSS"
        },

        //Placement

        {
            Name: "Mr. J. Prabhu Kiran",
            Position: "Placement Officer",
            Email: "placement@iittp.ac.in",
           phoneno: "8985464383 / 9182969286 / 0877-250 3672",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/PrabhuKiran.jpg",
            MenuName: "Placement"
        },
        {
            Name: "Mr. Abhinay Irala",
            Position: "Training and Placement Officer",
            Email: "placement_officer@iittp.ac.in",
            phoneno: "9966830630",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Abhinay_Irala.PNG",
            MenuName: "Placement"
        },

        // Student Affairs 

        {
            Name: "Mr. M. Venkat Ramana",
            Position: "Assistant Registrar",
            Email: "ar_sa@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Venkat_Ramana_AR.png",
            MenuName: "Student Affairs"
        },

        //Guest House (Visitors Hostel)

        {
            Name: "Mr. Chaman Mehta",
            Position: "Deputy Registrar",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Guest House (Visitors Hostel)"
        },

        {
            Name: "Mr. Abdul Rafi",
            Position: "Junior Assistant",
            Email: "rafi@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rafi.jpg",
            MenuName: "Guest House (Visitors Hostel)"
        },

         //Public Relation Office

         {
            Name: "Mr. Chaman Mehta",
            Position: "Deputy Registrar & Public Relation Officer",
            Email: "chaman@iittp.ac.in",
            phoneno: "0877 250 3507",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Chaman.jpg",
            MenuName: "Public Relation Office"
        },
        {
            Name: "Mr. Mahesh Kumar Mulakala",
            Position: "Assistant Public Relation Officer",
            Email: "maheshkumar@iittp.ac.in",
            phoneno: "9866454684",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/maheshkumar.jpg",
            MenuName: "Public Relation Office"
        },

       
        //  Sports

        {
            Name: "Dr. Iyappan. I",
            Position: "Sports Officer",
            Email: "iyappan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/iyyapan.png",
            MenuName: "Sports"
        },
        {
            Name: "Mr. Sreedhar Reddy T",
            Position: "Physical Training Instructor",
            Email: "tsreedharreddy@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sreedhar_Reddy_PTI.png",
            MenuName: "Sports"
        },

        // CSRC Office

        {
            Name: "Dr K. Thiruppathi",
            Position: "Chief Manager",
            Email: "kthiruppathi@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Thiruppathi.jpg",
            Email: "kthiruppathi@iittp.ac.in",
            MenuName: "CSRC Office"
        },
        {
            Name: "Mr. Rajan Babu Lankapalli",
            Position: "Deputy Registrar",
            Email: "rajanbabul@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/rajanbabu.png",
            MenuName: "CSRC Office"
        },
        {
            Name: "Mr. Ramesh. R",
            Position: "Assistant Registrar",
            Email: "rameshr@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Ramesh_photo.JPG",
            MenuName: "CSRC Office"
        },
        {
            Name: "Mr. Arun Kalyan Kuppannagari",
            Position: "Assistant Registrar",
            Email: "akk@iittp.ac.in",
            phoneno: "0877 250 3508",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Arun%20Kuppannagari.jpg",
            MenuName: "CSRC Office"
        },
        {
            Name: "Mr. Y. Vijay",
            Position: "Section Officer",
            Email: "vijay@iittp.ac.in",
            phoneno: " ",
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/vijay.jpg",
            MenuName: "CSRC Office"
        },

        {
            Name: "Mrs. S Vinodha",
            Position: "Project Manager",
            Email: "vinodha@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Vinodha.jpg",
            Email: "pm_csrc@iittp.ac.in",
            MenuName: "CSRC Office"
        },
        {
            Name: "Ms. K. Jayasree",
            Position: "Junior Executive",
            Email: "jayasreekencham@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/K.Jayasree.jpg",
            MenuName: "CSRC Office"
        },

        {
            Name: "Mr. Shaik Abdul Satthar",
            Position: "Junior Executive",
            Email: "shaikabdul@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/SHAIK ABDUL SATTHAR.jpg",
            MenuName: "CSRC Office"
        },
        {
            Name: "Ms. M. Ramya",
            Position: "Project Assistant",
            Email: "Ramya2099@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/M.Ramya.jpeg",
            MenuName: "CSRC Office"
        },

        // SwayamPrabha Project 

        {
            Name: "Mrs. Avanthi Allaparthi",
            Position: "Senior Project Officer",
            Email: "avanthi@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Avanthi_Allaparthi.jpg",
            Email: "avanthi@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },
        {
            Name: "Mr. Akshai P S",
            Position: "Senior Project Engineer",
            Email: "akshai@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Akshai.jpg",
            Email: "akshai@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },
        {
            Name: "Mr. I Bhanu Prakash",
            Position: "Senior Project Engineer",
            Email: "bhanu7785@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Bhanu_Prakash.jpg",
            Email: "bhanu7785@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },
        {
            Name: "Mr. Sujith Kumar S",
            Position: "Project Associate",
            Email: "sujithsenthilnathan@iittp.ac.in", // No email provided in the HTML
            phoneno: " ", // No phone number provided in the HTML
            Image: "https://files.iittp.ac.in/images/demo/iit/Staff/Sujith_Kumar_S_PA.png",
            Email: "sujithsenthilnathan@iittp.ac.in",
            MenuName: "SwayamPrabha Project"
        },

        // {
        //     Name: "Mr. Ajay T",
        //     Position: "Project Associate",
        //     Image: "https://files.iittp.ac.in/images/demo/iit/Staff/AJAY_PA.jpg",
        //     Email: "ajaythiyagarajan@iittp.ac.in",
        //     MenuName: "SwayamPrabha Project"
        // }
        // Add more director officers as needed...
    ]);
    const [selectedDirectorOfficers, setSelectedDirectorOfficers] = useState([]); // State to hold director officers related to the selected menu item

    useEffect(() => {
        // Filter DirectorOfficers based on MenuName to get officers related to the selected item (default: 'Director Office')
        const filteredDirectors = DirectorOfficers.filter(officer => officer.MenuName === selectedItem);
        setSelectedDirectorOfficers(filteredDirectors);
    }, [selectedItem, DirectorOfficers]); // Re-run effect when selectedItem or DirectorOfficers change

    const handleItemClick = (itemName) => {
        setSelectedItem(itemName);
    };

    return (
        <div>

            <Header />
            <Breadcrumb title="Home" subtitle="STAFF" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <Container>
                    <Row>

                        {/* Your menu items */}
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <ListGroup.Item as={Link} action to="/chemical-engineering-department" className={`p-3 mb-3`}>
                                <i className="fas fa-chevron-circle-right me-3"></i>
                                Faculty
                            </ListGroup.Item>
                            {/* Your menu items */}
                            <ListGroup className='listgroupmenu'>
                                <ListGroup.Item as="button" aria-expanded={selectedItem === 'Director Office'} onClick={() => handleItemClick('Director Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>Director Office
                                </ListGroup.Item>


                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Registrar Office'} onClick={() => handleItemClick('Registrar Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Registrar Office
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Dean Office'} onClick={() => handleItemClick('Dean Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Dean's Office
                                </ListGroup.Item>




                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'General Administration'} onClick={() => handleItemClick('General Administration')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    General Administration
                                </ListGroup.Item>


                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Establishment'} onClick={() => handleItemClick('Establishment')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Establishment
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Estate Office'} onClick={() => handleItemClick('Estate Office')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Estate Office
                                </ListGroup.Item>

                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Academic Affairs'} onClick={() => handleItemClick('Academic Affairs')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Academic Affairs
                                </ListGroup.Item>



                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Accounts'} onClick={() => handleItemClick('Accounts')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Accounts
                                </ListGroup.Item>



                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Purchase & Stores'} onClick={() => handleItemClick('Purchase & Stores')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Purchase & Stores
                                </ListGroup.Item>




                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Hindi Cell'} onClick={() => handleItemClick('Hindi Cell')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Hindi Cell
                                </ListGroup.Item>




                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Departments'} onClick={() => handleItemClick('Departments')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Departments
                                </ListGroup.Item>




                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'EngineeringUnit'} onClick={() => handleItemClick('EngineeringUnit')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    EngineeringUnit
                                </ListGroup.Item>



                                <ListGroup.Item as={Link} aria-expanded={selectedItem === 'Computer Centre'} onClick={() => handleItemClick('Computer Centre')}>
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Computer Centre
                                </ListGroup.Item>


                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Health Care'}
                                    onClick={() => handleItemClick('Health Care')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Health Care
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Hostels'}
                                    onClick={() => handleItemClick('Hostels')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Hostels
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'IAA'}
                                    onClick={() => handleItemClick('IAA')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    IAA
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Laboratories'}
                                    onClick={() => handleItemClick('Laboratories')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Laboratories
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Library'}
                                    onClick={() => handleItemClick('Library')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Library
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Recruitment'}
                                    onClick={() => handleItemClick('Recruitment')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Recruitment
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'NSS'}
                                    onClick={() => handleItemClick('NSS')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    NSS
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Placement'}
                                    onClick={() => handleItemClick('Placement')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Placement
                                </ListGroup.Item>


                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Student Affairs'}
                                    onClick={() => handleItemClick('Student Affairs')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Student Affairs
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === "Guest House (Visitors Hostel)"}
                                    onClick={() => handleItemClick("Guest House (Visitors Hostel)")}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Guest House (Visitors Hostel)
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === "Public Relation Office"}
                                    onClick={() => handleItemClick("Public Relation Office")}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Public Relation Office
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'Sports'}
                                    onClick={() => handleItemClick('Sports')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    Sports
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'CSRC Office'}
                                    onClick={() => handleItemClick('CSRC Office')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    CSRC Office
                                </ListGroup.Item>

                                <ListGroup.Item
                                    as={Link}
                                    to="#"
                                    aria-expanded={selectedItem === 'SwayamPrabha Project'}
                                    onClick={() => handleItemClick('SwayamPrabha Project')}
                                >
                                    <i className="fas fa-chevron-circle-right me-3"></i>
                                    SwayamPrabha Project
                                </ListGroup.Item>

                                {/* Add more ListGroup.Items for other menu items */}
                            </ListGroup>
                        </Col>
                        <Col md={9} className='c-right custom-padding-color '>
                            <div className='ms-3'>
                                

                                <h4 className='c-headline mt-2 mb-3'>{selectedItem}</h4>
                                <div className="row">
                                    {selectedDirectorOfficers.map((DirectorOfficer, index) => (
                                        <div key={index} className="col-xl-4 col-md-6">
                                            {/* Display information about each director officer */}
                                            <div className="single-team mb-40" style={{height:'402px',maxHeight:'410px',overflow:'auto'}}>
                                                <div className="team-thumb">
                                                    <div className="brd">
                                                        <a href="#">
                                                            <img src={DirectorOfficer.Image} alt="img" />
                                                        </a>
                                                    </div>
                                                </div>
                                                <div className="team-info">
                                                    <h4>
                                                        <a href={DirectorOfficer.namelink}>{DirectorOfficer.Name}</a>
                                                    </h4>
                                                    <div className="text-dark c-lineheight2">
                                                        <p><i className="fal fa-graduation-cap me-2" />{DirectorOfficer.Position}</p>
                                                        {(DirectorOfficer.Email !== undefined && DirectorOfficer.Email !== "") && (
                                                    
                                                            <p className="text-primary"><i className="fal fa-envelope me-1"></i> 
                                                                <a className='text-primary' href={`mailto:"${DirectorOfficer.Email}`}> {DirectorOfficer.Email}</a></p>
                                                                
                                                        )}
                                                        {(DirectorOfficer.phoneno !== undefined && DirectorOfficer.phoneno !== "") && (
                                                            <p className="text-dark"><i className="fas fa-phone-alt me-1"></i>  {DirectorOfficer.phoneno}</p>
                                                        )}
                                                        {(DirectorOfficer.Department !== undefined && DirectorOfficer.Department !=="") && (
                                                            <p className="text-danger font-weight-bold"><i className="fas fa-building me-1"></i>  {DirectorOfficer.Department}</p>

                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default YourComponent;
